import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEN from './locales/en/common.json';
import authEN from './locales/en/auth.json';
import lockEN from './locales/en/lock.json';
import settingsEN from './locales/en/settings.json';
import notesEN from './locales/en/notes.json';
import chatEN from './locales/en/chat.json';
import calendarEN from './locales/en/calendar.json';
import adminEN from './locales/en/admin.json';
import profileEN from './locales/en/profile.json';
import sharedEN from './locales/en/shared.json';
import errorsEN from './locales/en/errors.json';
import notificationsEN from './locales/en/notifications.json';
import breaksEN from './locales/en/breaks.json';

import commonTR from './locales/tr/common.json';
import authTR from './locales/tr/auth.json';
import lockTR from './locales/tr/lock.json';
import settingsTR from './locales/tr/settings.json';
import notesTR from './locales/tr/notes.json';
import chatTR from './locales/tr/chat.json';
import calendarTR from './locales/tr/calendar.json';
import adminTR from './locales/tr/admin.json';
import profileTR from './locales/tr/profile.json';
import sharedTR from './locales/tr/shared.json';
import errorsTR from './locales/tr/errors.json';
import notificationsTR from './locales/tr/notifications.json';
import breaksTR from './locales/tr/breaks.json';

import commonAR from './locales/ar/common.json';
import authAR from './locales/ar/auth.json';
import lockAR from './locales/ar/lock.json';
import settingsAR from './locales/ar/settings.json';
import notesAR from './locales/ar/notes.json';
import chatAR from './locales/ar/chat.json';
import calendarAR from './locales/ar/calendar.json';
import adminAR from './locales/ar/admin.json';
import profileAR from './locales/ar/profile.json';
import sharedAR from './locales/ar/shared.json';
import errorsAR from './locales/ar/errors.json';
import notificationsAR from './locales/ar/notifications.json';
import breaksAR from './locales/ar/breaks.json';

import commonFR from './locales/fr/common.json';
import authFR from './locales/fr/auth.json';
import lockFR from './locales/fr/lock.json';
import settingsFR from './locales/fr/settings.json';
import notesFR from './locales/fr/notes.json';
import chatFR from './locales/fr/chat.json';
import calendarFR from './locales/fr/calendar.json';
import adminFR from './locales/fr/admin.json';
import profileFR from './locales/fr/profile.json';
import sharedFR from './locales/fr/shared.json';
import errorsFR from './locales/fr/errors.json';
import notificationsFR from './locales/fr/notifications.json';
import breaksFR from './locales/fr/breaks.json';

import commonID from './locales/id/common.json';
import authID from './locales/id/auth.json';
import lockID from './locales/id/lock.json';
import settingsID from './locales/id/settings.json';
import notesID from './locales/id/notes.json';
import chatID from './locales/id/chat.json';
import calendarID from './locales/id/calendar.json';
import adminID from './locales/id/admin.json';
import profileID from './locales/id/profile.json';
import sharedID from './locales/id/shared.json';
import errorsID from './locales/id/errors.json';
import notificationsID from './locales/id/notifications.json';
import breaksID from './locales/id/breaks.json';

// Yeni bir modül çevrildikçe: locales/en|tr|ar|fr|id altına <modul>.json ekle,
// burada import edip resources + ns dizisine ekle.
i18n.use(initReactI18next).init({
  resources: {
    en: { common: commonEN, auth: authEN, lock: lockEN, settings: settingsEN, notes: notesEN, chat: chatEN, calendar: calendarEN, admin: adminEN, profile: profileEN, shared: sharedEN, errors: errorsEN, notifications: notificationsEN, breaks: breaksEN },
    tr: { common: commonTR, auth: authTR, lock: lockTR, settings: settingsTR, notes: notesTR, chat: chatTR, calendar: calendarTR, admin: adminTR, profile: profileTR, shared: sharedTR, errors: errorsTR, notifications: notificationsTR, breaks: breaksTR },
    ar: { common: commonAR, auth: authAR, lock: lockAR, settings: settingsAR, notes: notesAR, chat: chatAR, calendar: calendarAR, admin: adminAR, profile: profileAR, shared: sharedAR, errors: errorsAR, notifications: notificationsAR, breaks: breaksAR },
    fr: { common: commonFR, auth: authFR, lock: lockFR, settings: settingsFR, notes: notesFR, chat: chatFR, calendar: calendarFR, admin: adminFR, profile: profileFR, shared: sharedFR, errors: errorsFR, notifications: notificationsFR, breaks: breaksFR },
    id: { common: commonID, auth: authID, lock: lockID, settings: settingsID, notes: notesID, chat: chatID, calendar: calendarID, admin: adminID, profile: profileID, shared: sharedID, errors: errorsID, notifications: notificationsID, breaks: breaksID },
  },
  lng: 'tr', // gerçek değer App.js içinde runtime'da resolveInitialLocale() ile set edilir
  fallbackLng: 'en', // desteklenmeyen sistem dili (de, es, ...) -> İngilizce
  supportedLngs: ['en', 'tr', 'ar', 'fr', 'id'],
  ns: ['common', 'auth', 'lock', 'settings', 'notes', 'chat', 'calendar', 'admin', 'profile', 'shared', 'errors', 'notifications', 'breaks'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
